var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder-box",style:({border: [_vm.CHART_STATUS_TYPE__STYLE, _vm.CHART_STATUS_TYPE__EDIT].includes(_vm.type) ? '1px solid #e6e6e6' : ''})})}
var staticRenderFns = []

export { render, staticRenderFns }